export default __webpack_public_path__ + "static/media/kingdom-of-colors.439da5b7.jpg";